import styled from "styled-components";

const Logo = () => {
    return <Container>sincronia</Container>
}

const Container = styled.h1`
    margin-top: 0;
    font-size: 50px;
    text-transform: uppercase;
    letter-spacing: -3px;
    color: #494747;
`

export default Logo
  